<template>
  <div class="animated fadeIn">
    <b-form @submit="addOrUpdatePersonRecord">
      <b-row>
        <b-col md="9" sm="12" class="mb-4">
          <h4 v-if="this.person.id" class="card-title mb-0">{{ this.person.id }}</h4>
          <h4 v-if="!this.person.id" class="card-title mb-0">Create New Person</h4>
        </b-col>
        <b-col md="3" sm="12">

        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <PersonForm
            v-if="person.id"
            v-bind:person="person"
            :chooseOrganization="false"
            @updateVictimInfo="updateVictimInfo"
          ></PersonForm>
        </b-col>
      </b-row>
      <b-row align-h="end">
      <b-col cols="auto" class="p-3">
          <b-button variant="secondary" href="" @click.prevent="goBack">Cancel</b-button>
          <b-button variant="primary" @click="addOrUpdatePersonRecord">Submit</b-button>
          <b-button v-if="isAllowedToSharePerson" variant="primary" @click="addOrUpdatePersonRecordAndShare">Submit and Share</b-button>
        </b-col>
      </b-row>
      <b-modal :visible="showUpdatedModal && !shareAddon" title='Success' @ok="handleOk" header-bg-variant="success" header-text-variant="light" size="sm" centered id="modal1" ok-only>
        <template #modal-header-close>
          <h4>X</h4>
        </template>
        <h4>Person Record Updated Successfully</h4>
        <p>{{ person.id }}</p>
      </b-modal>
      <b-modal :visible="showUpdatedModal && shareAddon" title='Success' @ok="handleShare" header-bg-variant="success" header-text-variant="light" size="sm" centered id="modal1" ok-only>
         <template #modal-header-close>
          <h4>X</h4>
        </template>
        <h4>Person Record Updated Successfully</h4>
        <p>{{ person.id }}</p>
        <p v-if="!isRecordAlreadyShared">Click OK to set the Sharing Settings.</p>
        <p v-if="isRecordAlreadyShared">The record has already been shared.</p>
      </b-modal>
      <b-modal :visible="showErrorModal" title='Error' header-bg-variant="danger" header-text-variant="light" size="sm" centered id="error-modal" ok-only>
        <template #modal-header-close>
      <h4>X</h4>
    </template>
        <h4>An error occurred</h4>
        <p>Please select a context with a Group.</p>
      </b-modal>
    </b-form>
    <CreateSharePersonModal
      :person="person"
      :personId="personId"
      :personOrganizationOwner="personOrganizationOwner"
      :selectedGroup="selectedGroup"
      @createAndSharePerson="reroutePerson"
    ></CreateSharePersonModal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import PersonForm from '@/views/t1/PersonForm'
import CreateSharePersonModal from '@/components/Share/CreateSharePersonModal'
import userPermission from '@/mixins/userPermission'
import { getVictimStatusFromVictimInfo } from '@/helpers/victiminfo'

export default {
  name: 'editperson',
  mixins: [userPermission],
  components: {
    PersonForm,
    CreateSharePersonModal
  },
  computed: {
    ...mapGetters({
      userCurrentContext: 'userCurrentContext',
      person: 'getEditPerson',
      orientation_options: 'getOrientationOptions',
      race_options: 'getRaceOptions',
      services_provided: 'getServicesProvided',
      discharge_options: 'getDischargeOptions',
      victim_status_options: 'getVictimStatusOptions',
      immigration_options: 'getImmigrationOptions',
      ethnicity_options: 'getEthnicityOptions',
      gender_identity: 'getGenderIdentityOptions',
      gender_options: 'getGenderOptions',
      months: 'getMonths',
      showUpdatedModal: 'showUpdatedModal',
      sharedPersonRecords: 'sharePersonRecords',
      groupsByOrg: 'getGroupsByOrg',
      sexTraffickingMeans: 'getSexTraffickingMeans',
      laborTraffickingMeans: 'getLaborTraffickingMeans',
      victimInfoCreateError: 'getVictimInfoCreateError'
    }),
    selectedGroup: function () {
      return this.$store.getters.userCurrentContext.group
    },
    isRecordAlreadyShared () {
      return this.shareRecord && this.shareRecord.personShareStatus
    }
  },
  watch: {
    userCurrentContext: {
      async handler (newValue) {
        if (newValue) {
          this.personOrganizationOwner = _.get(this.userCurrentContext, 'organization.id')
          await this.$store.dispatch('getGroupsByOrg', { id: this.personOrganizationOwner })
          console.log('groupsByOrg', this.groupsByOrg)
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    goBack () {
      this.$router.go(-1)
    },

    handleOk (evt) {
      var id = this.$route.params.id
      this.$router.push({ path: `/person/` + id })

      // Reset pieces of state
      this.$store.commit('setShowUpdatedModal', false)
      this.$store.commit('resetEditPerson')
    },
    handleShare () {
      this.$store.commit('setShowUpdatedModal', false)
      if (this.isRecordAlreadyShared) {
        this.reroutePerson()
        return
      }

      this.$bvModal.show('create-share-person')
    },
    processPersonRecord () {
      const orgId = _.get(this.userCurrentContext, 'organization.id', false)
      const groupId = _.get(this.userCurrentContext, 'group.id', false)
      this.groupId = groupId

      this.$validator.validate().then(async (result) => {
        if (result) {
          let person = this.person

          if (this.person._id) {
            // https://github.com/sagalbot/vue-select/issues/239#issuecomment-333623907
            _.each(['p_le_agency', 'p_cac_agency', 'p_gang_county'], function (field) {
              if (_.isObject(person[field]) && person[field].value) {
                person[field] = person[field].value
              }
            }, this)

            if (this.person.p_presenting_offense !== 'Other') {
              this.person.p_presenting_offense_otherText = ''
            }

            if (this.person.b_disability !== 'Other') {
              this.person.b_disability_otherText = ''
            }

            if (this.person.p_guardian !== 'Other') {
              this.person.p_guardian_otherText = ''
            }

            if (this.person.p_le_agency !== 'Other') {
              this.person.p_le_agency_otherText = ''
            }

            if (this.person.selectedServices) {
              this.person.s_selected_services = this.person.selectedServices.join(',')
            }

            // Remove fields that we are auto-filling server-side
            // Don't allow them to update this
            // Remove associations
            const toDelete = [ 'organizationOwner', 'organizationCreator', 'createdBy', 'updatedBy', 'sharingGroups' ]
            toDelete.map((fieldName) => {
              delete this.person[fieldName]
            })

            await this.$store.dispatch('updatePerson', {
              ...this.person,
              orgId,
              groupId
            })
            await this.updatePersonVictimInfo(orgId, groupId)

            this.$store.commit('setShowUpdatedModal', true)
          }
        } else {
          alert('Please review form and submit all required answers.')
        }
      })
    },
    processShareRecord: function () {
      const personId = this.personId
      const groupId = this.$store.getters.userCurrentContext.group.id

      if (!personId || !groupId) {
        this.$store.commit('SET_SHARE_PERSON_RESPONSE', { success: false, error: { code: 'INVALID_API_CALL', message: 'Incorrect parameters' } })
      }

      if (personId && groupId) {
        this.$store.dispatch('sharePerson', {
          personId,
          groupId,
          fullTransfer: false,
          fullShare: false
        })
      }
    },

    async updatePersonVictimInfo (orgId, groupId) {
      await this.$store.dispatch('bulkUpdatePersonVictimInfo', {
        person: this.person._id,
        orgId,
        groupId,
        victimInfo: this.victimInfo
      })

      if (this.victimInfoCreateError) {
        this.$store.commit('SET_VICTIM_INFO_CREATE_ERROR', false)
        return
      }

      return this.$store.dispatch('updatePerson', {
        _id: this.person._id,
        b_confirmed: getVictimStatusFromVictimInfo(this.victimInfo),
        orgId,
        groupId
      })
    },

    addOrUpdatePersonRecord () {
      this.shareAddon = false
      this.processPersonRecord()
    },
    addOrUpdatePersonRecordAndShare () {
      this.shareAddon = true
      this.processPersonRecord()
    },
    reroutePerson () {
      const friendlyPersonId = this.$route.params.id
      this.$router.push({ path: `/person/` + friendlyPersonId })
    },

    updateVictimInfo (newValue) {
      this.victimInfo = newValue
    }
  },
  async created () {
    const friendlyPersonId = this.$route.params.id
    const orgId = _.get(this.userCurrentContext, 'organization.id', false)
    this.groupId = _.get(this.userCurrentContext, 'group.id', false)

    if (friendlyPersonId) {
      await this.$store.dispatch('getPersonForEdit', {
        id: friendlyPersonId,
        orgId: orgId,
        groupId: this.groupId
      })
      this.personId = this.person._id
      await this.$store.dispatch('getSharePersonRecords', {
        sperson: this.person._id,
        orgId: orgId,
        groupId: this.groupId
      })
      if (this.sharedPersonRecords) {
        this.shareRecord = this.sharedPersonRecords[0]
      }
    }
  },
  beforeDestroy () {
    this.$store.commit('resetEditPerson')
    this.$store.commit('SET_PERSON_VICTIM_INFO', [])
  },
  data: function () {
    return {
      t1plus: '',
      errors: [],
      month: '',
      day: '',
      year: '',
      tabindex: 0,
      personId: 0,
      personOrganizationOwner: 0,
      shareAddon: false,
      shareRecord: {},
      groupId: 0,
      showErrorModal: false,
      victimInfo: []
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/views/t1/EditPerson.vue